import React, { Component } from "react"
import MetaTags from "react-meta-tags"
import { Card, CardBody, CardText, Col, Container, Row } from "reactstrap"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import AdvertisingObjectiveContainer from "./components/AdvertisingObjectiveContainer"
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';


const buyingType_options = [
  { label: "Auction", value: "auction" },
  { label: "Reach & Frequency", value: "reach-and-frequency", disabled: true }
]

class CreateTikTokCampaign extends Component {

  constructor(props) {
    super(props)
  }

  state = {
    buying_type: buyingType_options[0]
  }

  render() {
    const { buying_type, advertising_objective } = this.state

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Campaign  | Mobihunter" />

          <Container fluid>
            <Breadcrumbs title="Dashboard" breadcrumbItem="Create TikTok campaign" link="/dashboard" />
            <Row className="justify-content-center">
              <Col xl={8} lg={12} md={12}>
                <Card>
                  <CardBody>
                    <CardText className="font-weight-semibold">Buying type</CardText>
                    <div className="btn-group" role="group">
                      {buyingType_options.map(i => (
                        <React.Fragment key={i.value}>
                          <input type="radio"
                                 className="btn-check"
                                 name="buying_type"
                                 id={i.value}
                                 value={i.value}
                                 disabled={i.disabled}
                                 checked={buying_type.value === i.value}
                                 onChange={() => this.setState({ buying_type: i })}
                          />
                          <label className="btn btn-outline-primary btn-sm" htmlFor={i.value}>{i.label}</label>
                        </React.Fragment>
                      ))}
                    </div>
                  </CardBody>
                </Card>
                {buying_type?.value === "auction"
                  ? <AdvertisingObjectiveContainer /> : <></>}
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

CreateTikTokCampaign.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      campaignId: PropTypes.node
    }).isRequired
  }).isRequired
}

const mapStateToProps = state => ({})

export default withRouter(
  connect(mapStateToProps, {})(CreateTikTokCampaign)
)
